import script from "./CatSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./CatSelect.vue?vue&type=script&setup=true&lang=js"

import "./CatSelect.vue?vue&type=style&index=0&id=3803f97c&scoped=true&lang=css"

import exportComponent from "D:\\phpstudy_pro\\data.yuandiansiyu.com\\platform_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3803f97c"]])

export default __exports__